import React, { useState, useEffect } from 'react';
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import Switch from "../../../components/UI/switch/switch";
import CustomInput from "../../../components/UI/customInput/customInput";
import { useTranslation } from "react-i18next";
import DatePickerCustom from "../../../components/datePicker/datePicker";
import Upload from "../../../components/UI/upload/upload";
import { useSelector } from "react-redux";
import { Get, Post } from "../../../apis/api";
import { toast } from "react-toastify";
import CustomButton from "../../../components/UI/customButton/customButton";
import CustomDatePickerTime from "../../../components/UI/customDatePickerTime/customDatePickerTime";
import { useVisaRegister } from './zustand';
import { InputField } from '../../../components/UI/InputField/InputField'

const FlightInformationStep = ({ changeStep, activeStep }) => {
  const [path, setPath] = useState(1)
  const { t } = useTranslation()
  const [form, setForm] = useState({ fly_type: 1 })
  const [airPort, setAirPort] = useState(null)
  const [ticketOne, setTicketOne] = useState({})
  const [ticketTwo, setTicketTwo] = useState({})
  const [loading, setLoading] = useState(false)
  const [dataAirport, setDataAirPort] = useState([])
  const [dataAirLine, setDataAirLine] = useState([])

  const { back, forward } = useVisaRegister()

  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleTicketOne = ({ name, value }) => {
    console.log(value)
    setTicketOne((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleTicketTwo = ({ name, value }) => {
    setTicketTwo((prevState) => ({ ...prevState, [name]: value }))
  }

  const cityList = useSelector((state) => state.setting.city)

  const handleSubmitFile = async () => {
    setLoading(true);
    const formData = new FormData();

    Object.keys(form).forEach(key => {
      formData.append(key, form[key]);
    });



    formData.append("form", "fly_form");

    const flyDetails = [
      { ...ticketOne, fly_date: ticketOne?.fly_date?.replace('T' ,' ')?.concat(':00'), land_date: ticketOne?.land_date?.replace('T' ,' ')?.concat(':00'), fly_way: 1 },
      { ...ticketTwo, fly_date: ticketTwo?.fly_date?.replace('T' ,' ')?.concat(':00'), land_date: ticketTwo?.land_date?.replace('T' ,' ')?.concat(':00'), fly_way: 2 }
    ];

    flyDetails.forEach((detail, index) => {
      index < form.fly_type &&
        Object.keys(detail).forEach(key => {
          formData.append(`fly_details[${index}][${key}]`, detail[key]);
        });
    });

    try {
      const res = await Post(`agent/visas/set-fly/${localStorage.getItem("visaId")}`, formData);
      toast.success(res.msg);
      forward()
    } catch (error) {
      toast.error(error.data.message);
    } finally {
      setLoading(false);
    }
  };
  const handleListAirport = () => {
    setLoading(true)
    Get(`basic-information/airport?page=${1}&per_page=${100}`).then((res) => {
      setDataAirPort(res?.details?.data?.data)
    }).catch(() => {
      toast.error("خطلایی رخ داده ")
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleListAirLine = () => {
    setLoading(true)
    Get(`basic-information/airline?page=${1}&per_page=${100}`).then((res) => {
      setDataAirLine(res?.details?.data?.data)
    }).catch(() => {
      toast.error("خطلایی رخ داده ")
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    if (activeStep)
      handleListAirport()
    handleListAirLine()
  }, [activeStep])


  return (
    <div className={`my-container ${activeStep ? "h-auto" : "h-0 overflow-hidden "}`}>
      <div className={"flex  justify-center mt-10"}>
        <Switch onChange={(e) => {
          handleForm({ name: "fly_type", value: e })
          setPath(e)
        }} />
      </div>

      <div className={" relative bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5 py-5 md:py-10 px-4 md:px-[13%] mb-8"}>

        <div className={"grid  grid-cols-1 md:grid-cols-2 gap-5 md:gap-10"}>
          <div className={"md:absolute md:right-5 md:top-[calc(50%-35px)] md:[writing-mode:vertical-lr] text-gray-500 text-center"}>
            {t("firstRoute")}
          </div>

          <CustomInput
            placeHolder={t("flightNumber")}
            label={t("flightNumber")}
            name={"fly_no"}
            onchange={(e) => handleTicketOne(e)}
          />
          <CustomSelect
            options={dataAirLine}
            placeHolder={"airlineName"}
            label={"airlineName"}
            name={"airline"}
            onchange={(e) => handleTicketOne(e)}
          />

          <CustomSelect
            options={dataAirport}
            placeHolder={"origin"}
            label={"origin"}
            name={"origin"}
            onchange={(e) => handleTicketOne(e)}
            searchField={['fa_name','en_name','code']}


          />

          <CustomSelect
            options={dataAirport}
            placeHolder={"to"}
            label={"to"}
            name={"destination"}
            onchange={(e) => handleTicketOne(e)}
            searchField={['fa_name','en_name','code']}


          />


          <div className='flex flex-row gap-4 items-center'>

            <InputField
              label={t('flightDateTime')}
              type='datetime-local'
              onChange={({ target: { value } }) => handleTicketOne({ name: 'fly_date', value })}
              dir='rtl'
              style={{fontFamily:'serif !important'}}
              className='en'
            />
          </div>


          <div className='flex flex-row gap-4 items-center'>

            <InputField
              label={t('landDateTime')}
              type='datetime-local'
              onChange={({ target: { value } }) => handleTicketOne({ name: 'land_date', value })}
              className='en'
            />
          </div>



          {/* <CustomDatePickerTime
            name={"fly_date"}
            placeholderTwo={t("timeOfFlight")}
            placeholder={t("dateOfFlight")}
            onChange={handleTicketOne}
          />
          <CustomDatePickerTime
            name={"land_date"}
            placeholderTwo={t("timeOfArrival")}
            placeholder={t("dateOfArrival")}
            onChange={handleTicketOne}
          /> */}
        </div>

      </div>
      {
        path === 2 &&
        <div className={" relative bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5 py-5 md:py-10 px-4 md:px-[13%] mb-8"}>

          <div className={"grid  grid-cols-1 md:grid-cols-2 gap-5 md:gap-10"}>
            <div className={"md:absolute md:right-5 md:top-[calc(50%-35px)] md:[writing-mode:vertical-lr] text-gray-500 text-center"}>
              {t("secondRoute")}
            </div>
            <CustomInput
              placeHolder={t("flightNumber")}
              label={t("flightNumber")}
              name={"fly_no"}
              onchange={(e) => handleTicketTwo(e)}
            />

            <CustomSelect
              options={dataAirLine}
              placeHolder={"airlineName"}
              label={"airlineName"}
              name={"airline"}
              onchange={(e) => handleTicketTwo(e)}
            />
            <CustomSelect
              options={dataAirport}
              placeHolder={"origin"}
              label={"origin"}
              name={"origin"}
              onchange={(e) => handleTicketTwo(e)}
              searchField={['fa_name','en_name','code']}
            />

            <CustomSelect
              options={dataAirport}
              placeHolder={"to"}
              label={"to"}
              name={"destination"}
              onchange={(e) => handleTicketTwo(e)}
              searchField={['fa_name','en_name','code']}



            />


            <div className='flex flex-row gap-4 items-center'>

              <InputField
                label={t('flightDateTime')}
                type='datetime-local'
                onChange={({ target: { value } }) => handleTicketTwo({ name: 'fly_date', value })}
                className='en'
              />
            </div>

            <div className='flex flex-row gap-4 items-center'>

              <InputField
                label={t('landDateTime')}
                type='datetime-local'
                onChange={({ target: { value } }) => handleTicketTwo({ name: 'land_date', value })}
                className='en'
              />
            </div>
            {/* <CustomDatePickerTime
              name={"fly_date"}
              placeholderTwo={t("timeOfFlight")}
              placeholder={t("dateOfFlight")}
              onChange={handleTicketTwo}
            />
            <CustomDatePickerTime
              name={"land_date"}
              placeholderTwo={t("timeOfArrival")}
              placeholder={t("dateOfArrival")}
              onChange={handleTicketTwo}
            /> */}
          </div>

        </div>
      }

      <div className={" relative bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5  py-4 px-4 md:px-[13%] mb-8 w-full"}>
        <div className={"absolute hidden md:block right-5 top-[calc(50%-35px)] [writing-mode:vertical-lr] text-gray-500"}>
          {t("ticketImage")}
        </div>
        <Upload onChange={(e) => handleForm({ name: e.name, value: e.value })} title={t("ticketImage")} name={"ticket_file"} />

      </div>
      {

        <div className={"flex justify-between  pt-10  items-center"}>
          <div onClick={back} className={"text-main cursor-pointer"}>{t("prevStep")}</div>
          <div className={"min-w-[330px]"}>
            <CustomButton loading={loading} onClick={() => handleSubmitFile()} title={"saveAndNext"} />
          </div>
        </div>
      }
    </div>
  );
};

export default FlightInformationStep;
